<template>
  <base-container ref="container" :isLoading="loading">
    <el-tabs tab-position="left" style="height: 100%">
      <el-tab-pane
        :label="leader.name + '组'"
        v-for="leader in leaders"
        :key="leader.id"
      >
        <WardGroupQueue :data="leader" @reload="loadData"></WardGroupQueue>
      </el-tab-pane>
    </el-tabs>
  </base-container>
</template>

<script>
import { getWardGroupQueues } from "@/api/bed/ward";
import WardGroupQueue from "./WardGroupQueue.vue";
export default {
  components: { WardGroupQueue },
  props: {
    wardId: String,
  },
  data() {
    return {
      loading: false,
      groups: [],
    };
  },
  computed: {
    leaders() {
      let leaders = this.groups.filter((c) => c.groupId == "0");
      leaders.forEach((c) => {
        c.members = this.groups.filter((g) => g.groupId == c.id);
      });
      return leaders;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      getWardGroupQueues(this.wardId)
        .then((res) => {
          this.groups = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.el-tabs >>> .el-tabs__content {
  height: 100%;
  padding: 0 0;
  overflow: auto;
}
.el-tabs >>> .el-tab-pane {
  height: 100%;
}
</style>
